import React, { useEffect } from 'react';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Assignment } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from '@tanstack/react-router';
import { DataGrid } from '@mui/x-data-grid';
import { actions } from '../ClientView.redux';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';

const ClientCharts = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { client_id } = useParams({ from: '/clients/view/$client_id' });
    const hasLoaded = useSelector((state) => state.clientView.chartsPreviouslyLoaded);
    const loading = useSelector((state) => state.clientView.chartsLoading);
    const charts = useSelector((state) => state.clientView.charts);
    const loadCharts = (clientID) => dispatch(actions.loadCharts(clientID));

    const columns = [
        { field: 'date_created', headerName: 'Date', flex: 1, minWidth: 140, sortable: false },
        { field: 'patient_name', headerName: 'Name', flex: 1, minWidth: 170, sortable: false },
        { field: 'patient_weight', headerName: 'Weight', flex: 1, minWidth: 120, sortable: false },
        { field: 'is_neutered', headerName: 'Neutered', flex: 1, minWidth: 120, sortable: false },
        { field: 'created_by', headerName: 'Created by', flex: 1, minWidth: 150, sortable: false },
    ];

    useEffect(() => {
        if (!hasLoaded && !loading) {
            loadCharts(client_id);
        }
    }, [loadCharts, client_id, hasLoaded, loading]);

    return (
        <DashboardCard
            color={'deepPurple'}
            icon={<Assignment />}
            topContent={'Charts'}
            topLabel="Click a chart to view or edit"
            size="xl"
        >
            <div style={{ width: '100%' }}>
                <DataGrid
                    rows={charts}
                    columns={columns}
                    getRowId={(row) => row.visit_id}
                    pagination
                    pageSizeOptions={[5, 10, 20, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    loading={loading}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableCellFocus
                    sx={{
                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                    }}
                    slots={{ pagination: NumberedDataGridPagination }}
                    onRowClick={(params) => navigate({ to: `/chart/${params.row.visit_id}` })}
                    autoHeight
                />
            </div>
        </DashboardCard>
    );
};

export default ClientCharts;
